import classNames from 'classnames';
import { ApsAppHeader, ApsGroup, ApsLanguageAvatar, ApsRoundButton } from 'UserExperience/portal-vnext';
import LogoAPI from './LogoAPI';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LanguageModal from './LanguageModal';
import { useSession } from '../../../../../common/session/SessionContext';


const HeaderAPI = ({ brandLogoUrl, brandName }) => {

  const match = useRouteMatch({
    path: '/HomeAPI',
    strict: false,
    sensitive: true
  });
  const { t, i18n } = useTranslation();
  const { language } = useSession();
  const history = useHistory();

  const backButtonClasses = classNames({
    'is-inactive': !!match
  });

  const goBack = () => {
    history.goBack();
  }

  const handleHomeClick = (e) => {
    if (!match) {
      history.goBack();
    }
  }
  
  const [isLanguageModalVisible, setIsLanguageModalVisible] = useState(false);

  const showLanguageModal = () => {
    setIsLanguageModalVisible(true);
  };

  const handleLanguageModalOk = () => {
    setIsLanguageModalVisible(false);
  };

  const handleLanguageModalCancel = () => {
    setIsLanguageModalVisible(false);
  };  

  useEffect(() => {
    if(language !== undefined){
      if(i18n.language !== language){
        i18n.changeLanguage(language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ApsAppHeader headerTitle={t('global.title')}>
      <LanguageModal
        visible={isLanguageModalVisible}
        onOk={handleLanguageModalOk}
        onCancel={handleLanguageModalCancel}
      />
      <ApsRoundButton
        buttonContent="back"
        buttonLocation="topbar"
        className={backButtonClasses}
        alt="Go Back"
        onClick={goBack}
      />
      <LogoAPI
        brandLogoUrl={brandLogoUrl}
        brandName={brandName}
      />
      <ApsGroup>
        <ApsLanguageAvatar
          avatarType={i18n.language}
          onClick={showLanguageModal}
          alt="Choose Language"
        />
        <ApsRoundButton
          buttonContent="home"
          buttonLocation="topbar"
          alt="Go to Start Page"
          onClick={handleHomeClick}
        />
      </ApsGroup>
    </ApsAppHeader>
  );
};

export default HeaderAPI;